/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { PostAlliancesGwsApplications200ResponseAlliance } from './post-alliances-gws-applications200-response-alliance';
// May contain unused imports in some cases
// @ts-ignore
import { PostAlliancesGwsApplications200ResponseApplicant } from './post-alliances-gws-applications200-response-applicant';
// May contain unused imports in some cases
// @ts-ignore
import { PostAlliancesGwsApplications200ResponseBillingAdminOrganization } from './post-alliances-gws-applications200-response-billing-admin-organization';
// May contain unused imports in some cases
// @ts-ignore
import { PostAlliancesGwsApplications200ResponseBillingAdminPerson } from './post-alliances-gws-applications200-response-billing-admin-person';
// May contain unused imports in some cases
// @ts-ignore
import { PostAlliancesGwsApplications200ResponseBillingUserAccount } from './post-alliances-gws-applications200-response-billing-user-account';

/**
 * 
 * @export
 * @interface PostAlliancesGwsApplications200Response
 */
export interface PostAlliancesGwsApplications200Response {
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGwsApplications200Response
     */
    'id': string;
    /**
     * 
     * @type {PostAlliancesGwsApplications200ResponseAlliance}
     * @memberof PostAlliancesGwsApplications200Response
     */
    'alliance': PostAlliancesGwsApplications200ResponseAlliance;
    /**
     * 
     * @type {PostAlliancesGwsApplications200ResponseApplicant}
     * @memberof PostAlliancesGwsApplications200Response
     */
    'applicant': PostAlliancesGwsApplications200ResponseApplicant;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGwsApplications200Response
     */
    'appliedAt': string;
    /**
     * 
     * @type {PostAlliancesGwsApplications200ResponseBillingAdminOrganization}
     * @memberof PostAlliancesGwsApplications200Response
     */
    'billingAdminOrganization': PostAlliancesGwsApplications200ResponseBillingAdminOrganization;
    /**
     * 
     * @type {PostAlliancesGwsApplications200ResponseBillingAdminPerson}
     * @memberof PostAlliancesGwsApplications200Response
     */
    'billingAdminPerson': PostAlliancesGwsApplications200ResponseBillingAdminPerson;
    /**
     * 
     * @type {PostAlliancesGwsApplications200ResponseBillingUserAccount}
     * @memberof PostAlliancesGwsApplications200Response
     */
    'billingUserAccount': PostAlliancesGwsApplications200ResponseBillingUserAccount;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGwsApplications200Response
     */
    'contractType': PostAlliancesGwsApplications200ResponseContractTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGwsApplications200Response
     */
    'edition': string;
    /**
     * 
     * @type {number}
     * @memberof PostAlliancesGwsApplications200Response
     */
    'numberOfIds': number;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGwsApplications200Response
     */
    'paymentPlan': PostAlliancesGwsApplications200ResponsePaymentPlanEnum;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGwsApplications200Response
     */
    'contactPersonName': string;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGwsApplications200Response
     */
    'contactTel': string;
    /**
     * 
     * @type {string}
     * @memberof PostAlliancesGwsApplications200Response
     */
    'contactEmail': string;
}

export const PostAlliancesGwsApplications200ResponseContractTypeEnum = {
    new: 'NEW',
    update: 'UPDATE'
} as const;

export type PostAlliancesGwsApplications200ResponseContractTypeEnum = typeof PostAlliancesGwsApplications200ResponseContractTypeEnum[keyof typeof PostAlliancesGwsApplications200ResponseContractTypeEnum];
export const PostAlliancesGwsApplications200ResponsePaymentPlanEnum = {
    monthly: 'MONTHLY',
    annual: 'ANNUAL'
} as const;

export type PostAlliancesGwsApplications200ResponsePaymentPlanEnum = typeof PostAlliancesGwsApplications200ResponsePaymentPlanEnum[keyof typeof PostAlliancesGwsApplications200ResponsePaymentPlanEnum];


